import { render, staticRenderFns } from "./EntregasContainer.vue?vue&type=template&id=726aa0f4&scoped=true"
import script from "./EntregasContainer.vue?vue&type=script&lang=js"
export * from "./EntregasContainer.vue?vue&type=script&lang=js"
import style0 from "./EntregasContainer.vue?vue&type=style&index=0&id=726aa0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726aa0f4",
  null
  
)

export default component.exports